module.exports = ".borderless td {  border: none;  }\n\ntable{\n  table-layout: fixed;\n}\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/search/desktop-search-results/desktop-search-results.component.css
// module id = ./src/app/search/desktop-search-results/desktop-search-results.component.css
// module chunks = main